import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives/compiled/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/compiled/text';

import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { SainAction } from '../../common/controller/analytics/hooks/sain-action';
import { useSAINUsageCriteriaMet } from '../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../common/controller/analytics/use-analytics';
import { AIFeedbackV2 } from '../../common/ui/ai-feedback-v2';
import { FEEDBACK_ENTRYPOINT_ID_TOPICS } from '../../constants';
import { onSentimentClick } from '../on-sentiment-click';

interface Props {
	prompt: string;
	attributes: Record<string, string>;
	location: string;
	userDetails: { id: string; name: string };
}

export const AITopicsSentimentFeedback = ({
	prompt,
	attributes,
	location,
	userDetails,
}: Props): React.JSX.Element => {
	const { commonAttributes } = useAIAnswerContext();
	const [fireAnalyticsEvent] = useAnalytics();
	const { fireSAINUsageEvent } = useSAINUsageCriteriaMet();
	const onLikeClick = () => {
		fireAnalyticsEvent(
			onSentimentClick({
				...attributes,
				sentiment: 'positive',
				location,
			}),
		);
		fireSAINUsageEvent({
			metCriteria: SainAction.POSITIVE_FEEDBACK_PROVIDED,
			commonAttributes,
		});
	};

	const onDislikeClick = () => {
		fireAnalyticsEvent(
			onSentimentClick({
				...attributes,
				sentiment: 'negative',
				location,
			}),
		);
		fireSAINUsageEvent({
			metCriteria: SainAction.NEGATIVE_FEEDBACK_PROVIDED,
			commonAttributes,
		});
	};

	return (
		<Inline alignBlock="center" space="space.050" testId="ai-topics-sentiment-feedback">
			<Text size="small" color="color.text.subtlest">
				{prompt}
			</Text>
			<AIFeedbackV2
				entrypointId={FEEDBACK_ENTRYPOINT_ID_TOPICS}
				userDetails={userDetails}
				attributes={attributes}
				attributesWithConsent={{}}
				onLikeButtonClickHandler={onLikeClick}
				onDislikeButtonClickHandler={onDislikeClick}
			/>
		</Inline>
	);
};
